import { CountryInclusionMode } from '~/graphqlTypes/globalTypes';
import { SimpleCountryFragment } from '~/graphqlTypes/SimpleCountryFragment';

/**
 * Given a country availability, which may be based on includes or excludes, normalize it into just
 * a list of includes. When mode is `include` or `exclude_all`, this always succeeds. When the mode
 * is `exclude` or `include_all`, it only succeeds when `allCountries` is always provided. Otherwise
 * it returns `null`, as it doesn't have enough information to normalize.
 */
export function normalizeCountries(
  mode: CountryInclusionMode,
  countryCodes: string[],
  allCountries: SimpleCountryFragment[],
): string[] {
  switch ( mode ) {
    case CountryInclusionMode.include:
      return countryCodes;
    case CountryInclusionMode.exclude_all:
      return [];
    case CountryInclusionMode.include_all:
      return allCountries.map( ( country ) => country.code );
    case CountryInclusionMode.exclude:
      return allCountries.filter( ( { code } ) => !countryCodes.includes( code ) ).map( ( { code } ) => code );
  }
}
